/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-05-10 14:36:19
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/mainPages/ListPage/index.ts
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import loadable from 'src/constrains/Loadable';
const CustomerDatabase = loadable(
  () => import('@/src/pages/CustomerDatabase/CustomerDatabase'),
);
const ProductsList = loadable(
  () => import('@/src/pages/ProductsList/ProductsList'),
);
const SalesChannel = loadable(
  () => import('@/src/pages/SalesChannels/SalesChannels'),
);
const ReviewList = loadable(
  () => import('src/pages/ProductReview/ProductReviewList'),
);

const AuditTrailCommunicationList = loadable(
  () => import('src/pages/AuditTrail/Communication/CommunicationList'),
);
const InventoryList = loadable(() => import('src/pages/Inventory/List'));
const reportList = loadable(
  () => import('@/src/pages/Analytics/Reports/ReportsList'),
);
const ReportingDashboard = loadable(
  () => import('@/src/pages/Analytics/ReportingDashboard'),
);
const ReportSubscriptionList = loadable(
  () => import('src/pages/Analytics/ReportSubscription/ReportSubscriptionList'),
);
const StockList = loadable(() => import('src/pages/Stock/List'));

// import CustomerDatabase from '@/src/pages/CustomerDatabase/CustomerDatabase';
// import ProductsList from '@/src/pages/ProductsList/ProductsList';
// import SalesChannel from '@/src/pages/SalesChannels/SalesChannels';
// import {
//   AuditTrailCommunicationList,
//   InventoryList,
//   reportList,
//   ReportingDashboard,
//   ReportSubscriptionList,
//   StockList,
// } from 'src/pages';
// import ReviewList from 'src/pages/ProductReview/ProductReviewList';

import { IRouteSubRoutes } from 'src/types/router';
import {
  productListPage,
  inventoryListPage,
  stockListPage,
  salesChannelGridPage,
  allCustomersGridPage,
  reviewListPage,
  communicationAuditTrailListPage,
  analyticsSubscriptionListPage,
  analyticsReportListPage,
  //analyticsDashboardPage,
} from '@/src/tools/permissions/storePermissions';
import {
  //EnumResources,

  EPermissionSource,
} from 'src/types/common/resources';
import { storeRoutes } from 'src/tools/urlMap';

export const listRoutes: IRouteSubRoutes[] = [
  {
    exact: true,
    path: storeRoutes.storeProductList, //'/productsList',
    component: ProductsList,
    isPrivate: true,
    permissionGroup: productListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.inventoryList, //'/inventoryList',
    component: InventoryList,
    isPrivate: true,
    permissionGroup: inventoryListPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.storeStockList, // '/stockList',
    component: StockList,
    isPrivate: true,
    permissionGroup: stockListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.salesChannelList, // '/salesChannels',
    component: SalesChannel,
    isPrivate: true,
    permissionGroup: salesChannelGridPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.customerDatabaseList, //'/customerDatabase',
    component: CustomerDatabase,
    isPrivate: true,
    permissionGroup: allCustomersGridPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.reviewList, //'/reviewList',
    component: ReviewList,
    isPrivate: true,
    permissionGroup: reviewListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.communicationList, //'/communicationList',
    component: AuditTrailCommunicationList,
    isPrivate: true,
    permissionGroup: communicationAuditTrailListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.reportSubscriptionList, //'/reportSubscriptionList',
    component: ReportSubscriptionList,
    isPrivate: true,
    permissionGroup: analyticsSubscriptionListPage,
    source: EPermissionSource.store,
  },

  {
    exact: true,
    path: storeRoutes.reportList, //'/reportList',
    component: reportList,
    isPrivate: true,
    permissionGroup: analyticsReportListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.dashboard, // '/',
    component: ReportingDashboard,
    isPrivate: true,
    //permissionGroup: analyticsDashboardPage,
    // source: EPermissionSource.store,
  },
];
